import { render } from "./MClinics.vue?vue&type=template&id=4d4e6dc8"
import script from "./MClinics.vue?vue&type=script&lang=js"
export * from "./MClinics.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__